"use client";

import { addNextjsError } from "@datadog/browser-rum-nextjs";
import { Button } from "@repo/ui";
import Link from "next/link";
import { useEffect } from "react";

import { NavigationLogo } from "@/components/navigation-logo";

//This is the error screen
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Report to Datadog RUM. RUM auto-captures unhandled exceptions, but errors
    // caught by this boundary are "handled" by React and would otherwise be
    // invisible; addNextjsError also links Server Component errors via
    // error.digest to the backend logs.
    addNextjsError(error);
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col">
      <main className="bg-background flex flex-1 flex-col items-center justify-center pt-40 pb-40 text-center">
        <div className="mb-8">
          <NavigationLogo className="h-12 w-auto" />
        </div>
        <h1 className="text-foreground text-4xl font-normal tracking-tight sm:text-5xl">
          Something went wrong!
        </h1>
        <p className="text-muted-foreground mt-4 text-lg">
          We encountered an error while loading this page.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Button onClick={reset} className="rounded-full">
            Try again
          </Button>
          <Button asChild variant="outline" className="rounded-full">
            <Link href="/home">Go back home</Link>
          </Button>
        </div>
      </main>
    </div>
  );
}
